import { render, staticRenderFns } from "./RosterTable.vue?vue&type=template&id=eb83fc0a"
import script from "./RosterTable.vue?vue&type=script&lang=js"
export * from "./RosterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports